export enum ESPressoFeatureFlags {
    UnblockUserButton = 'auth0-unblock-user-account',
    Auth0EnforceNovaOAuth = 'auth0-enforce-nova-oauth'
}
